import { render, staticRenderFns } from "./well_former.vue?vue&type=template&id=78791588&"
import script from "./well_former.vue?vue&type=script&lang=js&"
export * from "./well_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports